import React, { useState, useCallback, useEffect, useRef } from "react";
import { ThemeProvider } from "@mui/material/styles";
import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  MenuItem,
  Tooltip,
  Autocomplete,
  ListItemText,
  Typography,
  Chip,
  Card,
} from "@mui/material";
import {
  StyledTableCellHistory,
  StyledTableRowHistory,
  StyledTextField,
  StyledButton,
  OutlinedIconFab,
  theme,
  StyledCheckbox,
} from "../StyledComponents";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import ClearIcon from "@mui/icons-material/Clear";
import { medicineDurationTypesOptions } from "../initialData/initialData";
import Icon from "../Utils/Icons";
import { MedicationsTable } from "../Sections/MedicationsTable";
const MedicationsSimplified = ({
  activeSection,
  handleCrossButtonClick,
  data,
  setData,
  reasonsOptions,
  routeAutoData,
  initialObservationData,
  startRecording,
  stopRecording,
  isAiEnabled,
}) => {
  const [listeningOn, setListeningOn] = useState(false);
  const [newMedicine, setNewMedicine] = useState({
    id: null,
    term: "",
    selectedAdministration: null,
    reasons: [],
    frequency: "",
    duration: "",
    durationType: "Days",
    instructions: "",
    medicineNote: "",
  });

  const [medicineName, setMedicineName] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [medicines, setMedicines] = useState(data);
  const [validationErrors, setValidationErrors] = useState({
    id: null,
    term: "",
    selectedAdministration: null,
    reasons: "",
    frequency: "",
    duration: "",
    instructions: "",
    medicineNote: "",
  });

  useEffect(() => {
    setMedicines(data);
  }, [data]);

  const validateFields = () => {
    const errors = {};

    // Validate Medicine Name
    if (!newMedicine.term && medicineName.length === 0) {
      errors.term = "Medicine Name is a mandatory field.";
    }
    // Validate Frequency
    if (!newMedicine.frequency && newMedicine.frequency?.length === 0) {
      errors.frequency = "Direction of Use is a mandatory field.";
    }

    // Validate Duration
    // if (!newMedicine.duration) {
    //   errors.duration = "Duration is a mandatory field.";
    // } else
    if (newMedicine?.duration < 0) {
      errors.duration = "Duration must not be a negative number.";
    }

    setValidationErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleAdd = async () => {
    if (!validateFields()) {
      return; // Exit if validation fails
    }

    let newDetails = { ...newMedicine };

    // Add the new term to the complaints list
    let updatedDetails = [...medicines, newDetails];
    console.log("Diagnosis Updated Details", updatedDetails);
    setMedicines(updatedDetails);
    setNewMedicine({
      id: null,
      term: "",
      selectedAdministration: null,
      reasons: [],
      frequency: "",
      duration: "",
      durationType: "Days",
      instructions: "",
      medicineNote: "",
    });
    setValidationErrors({}); // Clear errors after successful submission
    setMedicineName("");
    setData(updatedDetails);
  };

  const handleInputChange = (field, value) => {
    let newDetails;

    if (field === "term") {
      newDetails = {
        ...newMedicine,
        [field]: value.term,
        id: value.id,
      };
    } else {
      newDetails = {
        ...newMedicine,
        [field]: value,
      };
    }

    setNewMedicine(newDetails);
  };

  // Function to handle row edit
  const handleEditRow = (index) => {
    setMedicineName(medicines[index].term);
    setNewMedicine({ ...medicines[index], id: null });
    setEditingIndex(index);
    // handleDeleteRow(index); // Remove the row from the list temporarily
  };
  console.log("Editing Index", editingIndex);
  const handleUpdate = async () => {
    if (!validateFields()) {
      return; // Exit if validation fails
    }

    let newDetails = { ...newMedicine, source: undefined };

    let updatedDetails = medicines.map((data, i) =>
      i == editingIndex ? newDetails : data
    );
    setMedicines(updatedDetails);
    setEditingIndex(null);
    setNewMedicine({
      id: null,
      term: "",
      selectedAdministration: null,
      reasons: [],
      frequency: "",
      duration: "",
      durationType: "Days",
      instructions: "",
      medicineNote: "",
    });
    setValidationErrors({}); // Clear errors after successful submission
    setMedicineName("");
    setData(updatedDetails);
  };
  // Function to handle row delete
  const handleDeleteRow = (index) => {
    let updatedDetails = medicines.filter((_, i) => i !== index);
    setMedicines(updatedDetails);
    setData(updatedDetails);
  };

  const handleClearName = () => {
    setValidationErrors({});
    setMedicineName("");
    setNewMedicine({
      ...newMedicine,
      term: "", // Use computed property name to set the field dynamically
    });
  };

  const handleConditionTyped = (value) => {
    setMedicineName(value);
    handleInputChange("term", { term: value, id: null });
  };

  console.log("Medicines data", medicines);
  console.log("Reasons", reasonsOptions);
  return (
    <ThemeProvider theme={theme}>
      {activeSection && (
        <>
          <Card
            sx={{
              borderRadius: "10px",
              boxShadow: "0 4px 4px 0 #C7C7CC inset",
              backgroundColor: "#FFF",
              backgroundImage: "url(/newImages/medicationsBackground.svg)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <Grid item xs={12} sm={12} md={12}>
              <Grid
                container
                spacing={2}
                sx={{
                  marginTop: "5px",
                  padding: "10px",
                }}
              >
                <Grid item xs={12} sm={7} md={6}>
                  <StyledTextField
                    value={medicineName}
                    onChange={(e) => {
                      handleConditionTyped(e.target.value);
                    }}
                    InputProps={{
                      endAdornment: (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div style={{ marginRight: "5px" }}>
                            <Tooltip title="Clear">
                              <OutlinedIconFab
                                size="small"
                                variant="contained"
                                onClick={handleClearName}
                              >
                                <Icon name="clearTextField" size={32} />
                              </OutlinedIconFab>
                            </Tooltip>
                          </div>

                          {/* <>
                            {isAiEnabled &&
                              (listeningOn === false ? (
                                <Tooltip title="Start Listening">
                                  <OutlinedIconFab
                                    onClick={() => {
                                      startRecording();
                                      setListeningOn(true);
                                    }}
                                    variant="contained"
                                    color="defaultColor"
                                    size="small"
                                  >
                                    <Icon name="micNotInUse" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                              ) : (
                                <Tooltip title="Stop Listening">
                                  <OutlinedIconFab
                                    onClick={() => {
                                      // SpeechRecognition.stopListening();
                                      stopRecording("Medications");
                                      setListeningOn(false);
                                    }}
                                    variant="outlined"
                                    color="defaultColor"
                                    size="small"
                                  >
                                    <Icon name="micInUse" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                              ))}
                          </> */}
                        </div>
                      ),
                    }}
                    label="Medicine Name"
                    fullWidth
                    error={!!validationErrors.term} // Highlight field in red if there's an error
                    helperText={validationErrors.term} // Show error message
                  />
                </Grid>
                <Grid item xs={6} sm={5} md={6}>
                  <StyledTextField
                    fullWidth
                    label="Direction of Use"
                    error={!!validationErrors.frequency}
                    helperText={validationErrors.frequency}
                    value={newMedicine.frequency}
                    onChange={(e) =>
                      handleInputChange("frequency", e.target.value)
                    }
                  />
                </Grid>

                <Grid container item xs={7} sm={6} md={3} spacing={2}>
                  <Grid item xs={5} lg={4}>
                    <StyledTextField
                      type="number"
                      label="Duration"
                      variant="outlined"
                      value={newMedicine.duration}
                      size="small"
                      inputProps={{ min: 0 }}
                      onChange={(e) =>
                        handleInputChange("duration", e.target.value)
                      }
                      error={!!validationErrors.duration} // Highlight field in red if there's an error
                      helperText={validationErrors.duration} // Show error message
                    />
                  </Grid>
                  <Grid item xs={7} lg={8}>
                    <StyledTextField
                      fullWidth
                      label="Duration Type"
                      select
                      value={newMedicine?.durationType || "days"}
                      onChange={(e) =>
                        handleInputChange("durationType", e.target.value)
                      }
                    >
                      {medicineDurationTypesOptions.map((status, index) => (
                        <MenuItem key={index} value={status}>
                          {status}
                        </MenuItem>
                      ))}
                    </StyledTextField>
                  </Grid>
                </Grid>
                <Grid item xs={5} sm={6} md={2}>
                  <Autocomplete
                    options={routeAutoData} // Predefined options for selection
                    value={newMedicine.selectedAdministration} // Bind to the selected value
                    onChange={
                      (event, newValue) =>
                        handleInputChange("selectedAdministration", newValue) // Update state on selection change
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    } // Define equality check
                    renderInput={(params) => (
                      <StyledTextField
                        {...params}
                        label="Administration"
                        placeholder="Select administration method"
                        fullWidth
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={5} md={3}>
                  <Autocomplete
                    multiple
                    limitTags={1}
                    options={reasonsOptions} // Predefined list of options
                    value={newMedicine.reasons} // Bind selected values
                    onChange={(event, newValue) => {
                      handleInputChange("reasons", newValue); // Store only the 'condition' values
                    }}
                    renderInput={(params) => (
                      <StyledTextField {...params} label="Reasons" fullWidth />
                    )}
                  />
                </Grid>

                <Grid item xs={8} sm={5} md={3}>
                  <StyledTextField
                    fullWidth
                    label="Notes"
                    value={newMedicine.medicineNote}
                    onChange={(e) =>
                      handleInputChange("medicineNote", e.target.value)
                    }
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  md={1}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <StyledButton
                    bgColor="#0E3F66"
                    onClick={editingIndex != null ? handleUpdate : handleAdd}
                    variant="contained"
                    sx={{
                      fontSize: { xs: "0.8rem", sm: "1rem" },
                      width: "100%",
                    }}
                  >
                    {editingIndex != null ? "Update" : "Add"}
                  </StyledButton>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </>
      )}
      {medicines && (
        <MedicationsTable
          data={medicines}
          activeSection={activeSection}
          handleEditRow={handleEditRow}
          handleDeleteRow={handleDeleteRow}
        />
      )}
    </ThemeProvider>
  );
};

export default MedicationsSimplified;
